import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments';
import { FileUploadResultModel } from '@models/request-creation.models';
import { CompanyContextService } from '@services/company-context/company-context.service';
import { map, take } from 'rxjs';
import { downloadFileFromBlob } from 'utils/file-downloader';

@Injectable({
  providedIn: 'root',
})
export class CreateRequestService {
  readonly #http = inject(HttpClient);

  readonly #companyContextService = inject(CompanyContextService);

  public downloadTemplate() {
    const url = `${environment.apiConfig.baseUrl}/create-request/template`;

    return this.#http.get(url, { responseType: 'blob' }).pipe(
      map(response => {
        const companyName = this.#companyContextService.currentCompany()?.name || '';
        downloadFileFromBlob(response, `Classification Request Template - ${companyName}.xlsx`);

        return response;
      })
    );
  }

  public uploadFile(file: File) {
    const url = `${environment.apiConfig.baseUrl}/create-request/validate`;

    const formData = new FormData();
    formData.append('file', file);

    return this.#http.post<FileUploadResultModel>(url, formData).pipe(
      map(r => new FileUploadResultModel(r.requestValidationSubmissionId, r.errorMessage)),
      take(1)
    );
  }
}
